import { useEffect, useState } from "react";
import { Step, Stepper } from '@progress/kendo-react-layout';
import { KitStatus, Status } from "../../models/kitStatus";

const tramStatus = {
    standardTram: [Status.CreatedStatus, Status.ReceivedStatus, Status.ProcessingStatus, Status.CompletedStatus, Status.EmailSentStatus],
    reviewTram: [Status.CreatedStatus, Status.ReceivedStatus, Status.ProcessingStatus, Status.ReviewStatus, Status.CompletedStatus, Status.EmailSentStatus],
    errorTram: [Status.CreatedStatus, Status.ReceivedStatus, Status.ProcessingStatus, Status.ErrorStatus],
    errorReviewTram: [Status.CreatedStatus, Status.ReceivedStatus, Status.ProcessingStatus, Status.ReviewStatus, Status.ErrorStatus]
}

const KitStatusStep = (kitStatus: any) => {
    return (<Step {...kitStatus}>
        <span className="k-step-indicator" aria-hidden="true">
        </span>
        <span className="k-step-label">
            <span className="k-step-text">{kitStatus.name}</span>
        </span>
    </Step>)
}

interface SubmittedKitTramLineProps {
    kitStatusId?: KitStatus,
    review?: boolean,
    children?: React.ReactNode
}

export const SubmittedKitTramLine = (props: SubmittedKitTramLineProps) => {
    const [stepperIndex, setStepperIndex] = useState(0);
    const [tramLineItems, setTramLineItems] = useState(tramStatus.standardTram);

    useEffect(() => {
        let tramLine = undefined as undefined | any[];
        if (props.review) {
            tramLine = (props.kitStatusId === KitStatus.Error) ?
                tramStatus.errorReviewTram :
                tramStatus.reviewTram;
        } else {
            tramLine = (props.kitStatusId === KitStatus.Error) ?
                tramStatus.errorTram :
                tramStatus.standardTram;
        }

        setTramLineItems(tramLine);

        var index = tramLine.findIndex(x => x.id === props.kitStatusId);
        (index === -1) ?
            setStepperIndex(0) :
            setStepperIndex(index);

    }, [props.kitStatusId, props.review])

    return <Stepper
        item={KitStatusStep}
        value={stepperIndex}
        items={tramLineItems}
    />;
}